import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from './auth/login/Login'
import ForgotPassword from './auth/login/ForgotPassword'
import RessetPassword from './auth/login/ResetPassword'
import ForgotPasswordMobile from './auth/login/ForgotPasswordMobile'
import RessetPasswordMobile from './auth/login/ResetPasswordMobile'
import Master from './theme/AppMaster'
import SideBar from './theme/AppSideBar'
import './App.css';
import './environments/Global'
import './environments/API'

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Escoge el basename según entorno
const basename = isLocalhost
  ? process.env.REACT_APP_BASENAME_LOCAL
  : process.env.REACT_APP_BASENAME_PROD;

function App() {
  const [user, setUser] = useState(localStorage.getItem('userToken'))
  const [menu, setMenu] = useState([])
  useEffect(() => {
    const loggedUserJson = localStorage.getItem('userToken')
    setMenu(JSON.parse(localStorage.getItem(global.MENU_MODULE_SELECT)));
    if (loggedUserJson) {
      const user = loggedUserJson
      setUser(user)
    }
  }, [])
  return (
    <>
      <BrowserRouter basename={basename}>
        {
          user === null
            ?
            <Routes>
              <Route path={global.ROUTE_LOGIN} name="Home" element={<Login />} />
              <Route path={global.ROUTE_ANY} name="Login" element={<Login />} />
              <Route path={global.FORGOTPASSWORD} name="Forgot Password" element={<ForgotPassword />} />
              <Route path={global.RESETPASSWORD} name="Forgot Password" element={<RessetPassword />} />
              <Route path={global.FORGOTPASSWORDMOBILE} name="Forgot Password" element={<ForgotPasswordMobile />} />
              <Route path={global.RESETPASSWORDMOBILE} name="Forgot Password" element={<RessetPasswordMobile />} />
            </Routes>
            :
            <Routes>
              <Route path={global.ROUTE_HOME} name="Home" element={<Master />} />
            </Routes>
        }
        <SideBar menu={menu} />
      </BrowserRouter>
    </>
  )
}

export default App;
